import { Map, fromJS } from 'immutable';
import {
  SET_PROJECT,
  SET_PROJECT_UNDOABLE,
  REMOVE_PROJECT_IMAGE,
} from './project';
import {
  IMAGE_ADDED,
  UPDATE_IMAGE_COUNTS,
  IMAGE_REMOVED,
} from '../sagas/ReturnedChangesetProcessor';

const imageUsageReducer = (state = new Map(), action) => {
  switch (action.type) {
    case SET_PROJECT_UNDOABLE:
    case SET_PROJECT:
      if (action.project.images) {
        for (const imageID of Object.keys(action.project.images)) {
          const image = action.project.images[imageID];
          state = state.set(imageID, fromJS(image.usage));
        }
      }

      return state;

    case IMAGE_ADDED:
      const image = action.image;
      if (!image.hasOwnProperty('usage') || image.usage === null) {
        if (!state.has(image.imageID)) {
          state = state.set(image.imageID, fromJS([]));
        }
      } else {
        state = state.set(image.imageID, fromJS(image.usage));
      }

      return state;

    case REMOVE_PROJECT_IMAGE:
      if (Array.isArray(action.image)) {
        for (const imageID of action.image) {
          state = state.delete(imageID);
        }
      } else {
        state = state.delete(action.image);
      }

      return state;

    case IMAGE_REMOVED:
      return state.delete(action.image);

    case UPDATE_IMAGE_COUNTS:
      let workingState = state;
      const addedImages = action.deltas.addedImages.filter((a) => !!a);
      const removedImages = action.deltas.removedImages.filter((a) => !!a);
      const { spreadID } = action;
      const pages = action.pages ? action.pages : null;

      for (const imageID of addedImages) {
        const stateUsage = workingState.get(imageID);
        if (
          !stateUsage.some(
            (item) =>
              item === spreadID ||
              (item.get && item.get('spreadID') === spreadID),
          )
        ) {
          const newEntry = { spreadID };
          if (pages) {
            newEntry.pages = [pages];
          }

          workingState = workingState.update(imageID, (usage) => {
            return usage.push(fromJS(newEntry));
          });
        } else {
          workingState = workingState.update(imageID, (usage) => {
            return usage.map((item) => {
              if (
                item === spreadID ||
                (item.get && item.get('spreadID') === spreadID)
              ) {
                if (pages) {
                  return item.set('pages', fromJS([pages]));
                }
              }
              return item;
            });
          });
        }
      }

      for (const imageID of removedImages) {
        workingState = workingState.update(imageID, (usage) => {
          return usage.filter(
            (item) =>
              item !== spreadID &&
              item.get &&
              item.get('spreadID') !== spreadID,
          );
        });
      }

      return workingState;
  }

  return state;
};

export default { reducer: imageUsageReducer };
